import { gsap } from 'gsap';

let performanceStats = {
  averageFrameTime: 0,
  droppedFrames: 0,
  totalFrames: 0,
};

const suppressResizeObserverError = () => {
  const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
  const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
  if (resizeObserverErrDiv) {
    resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
  if (resizeObserverErr) {
    resizeObserverErr.setAttribute('style', 'display: none');
  }
};

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message.includes('Cannot read properties of null (reading \'ownerDocument\')') ||
      e.message.includes('Chart resize error') ||
      e.message.includes('helpers.dom.ts')) {
    suppressResizeObserverError();
    e.stopImmediatePropagation();
    return false;
  }
});

export const initializeGSAP = () => {
  const isLowEndDevice = navigator.hardwareConcurrency < 4 || navigator.deviceMemory < 4;
  const isMobile = window.innerWidth < 768;

  gsap.ticker.lagSmoothing(1000, 16);

  if (isLowEndDevice || isMobile) {
    gsap.ticker.fps(30);
  } else {
    gsap.ticker.fps(60);
  }

  if (process.env.NODE_ENV === 'development') {
    let lastTime = performance.now();

    gsap.ticker.add(() => {
      const currentTime = performance.now();
      const frameTime = currentTime - lastTime;

      performanceStats.totalFrames++;
      performanceStats.averageFrameTime =
        (performanceStats.averageFrameTime * (performanceStats.totalFrames - 1) + frameTime) /
        performanceStats.totalFrames;

      if (frameTime > 20) {
        performanceStats.droppedFrames++;
      }

      lastTime = currentTime;

      if (performanceStats.totalFrames % 1800 === 0) {
        const droppedPercentage = (performanceStats.droppedFrames / performanceStats.totalFrames) * 100;
        const avgFrameTime = performanceStats.averageFrameTime;

        if (droppedPercentage > 10 || avgFrameTime > 30) {
          // Only show warnings if performance is significantly degraded
          console.warn('⚠️ GSAP Performance Warning:', {
            averageFrameTime: avgFrameTime.toFixed(2) + 'ms',
            droppedFrames: performanceStats.droppedFrames,
            droppedFramePercentage: droppedPercentage.toFixed(2) + '%',
            suggestion: avgFrameTime > 25 ? 'Consider reducing animation complexity' : 'Consider reducing concurrent animations'
          });
        }
        // Silently track good performance without logging
      }
    });
  }

  gsap.defaults({
    force3D: true,
    lazy: false,
  });
};

export default initializeGSAP;